import React, { Component, Fragment } from "react";
import { Segment, Item } from "semantic-ui-react";

class SiteFooter extends Component {
  render() {
    return (
      <Fragment>
        <Segment basic className="footer">
          &copy; {new Date().getFullYear()} {" "}
          <Item as="a" href="http://xcmsolutions.com/" target="_blank">
          Wolters Kluwer N.V. and/or its subsidiaries.
          </Item>{" "}
          All rights reserved.
        </Segment>
      </Fragment>
    );
  }
}

export default SiteFooter;
